function initBeforeAfter() {
  document.querySelectorAll('.before-after--real').forEach(container => {

    let isDragging = false;

    function move(x) {
      const rect = container.getBoundingClientRect();
      let pos = ((x - rect.left) / rect.width) * 100;
      pos = Math.max(0, Math.min(100, pos));
      container.style.setProperty('--pos', pos + '%');
    }

    const cursor = container.querySelector('.before-after__cursor');

    cursor.addEventListener('mousedown', () => isDragging = true);
    window.addEventListener('mouseup', () => isDragging = false);

    window.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      move(e.clientX);
    });

    cursor.addEventListener('touchstart', () => isDragging = true);
    window.addEventListener('touchend', () => isDragging = false);

    window.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      move(e.touches[0].clientX);
    });

    container.addEventListener('dragstart', e => e.preventDefault());
  });
}

document.addEventListener("DOMContentLoaded", initBeforeAfter);
document.addEventListener("shopify:section:load", initBeforeAfter);
